import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type StatisticsTabProps = {
    label: string;
};

const StatisticsRoute = '/statistics';

let routes = [StatisticsRoute];

function StatisticsTab({ label, ...props }: StatisticsTabProps) {
    function handleClick() {
        history.push(StatisticsRoute);
    }

    return <BaseTab {...props} label={label} onClick={handleClick} route={StatisticsRoute} />;
}

function TranslatedStatisticsTab(props) {
    const label = Translate('header/nav/statistics');
    return <StatisticsTab {...props} label={label} />;
}

TranslatedStatisticsTab.routes = routes;

export default TranslatedStatisticsTab;
